import { getInvoices, openFilter } from 'reduxpath/ducks/ZotapayInvoices/List'
import { getCountries } from 'reduxpath/ducks/Reference'

import Home from 'units/ZotapayInvoices'
import List from 'units/ZotapayInvoices/units/List'

const list = (store) => {
  const { qs } = store.getState().ZotapayInvoices
  store.dispatch(getInvoices(qs))
  store.dispatch(getCountries())
}

const listLeave = (store) => {
  store.dispatch(openFilter(false))
}

export default {
  populate: {
    list,
    listLeave,
  },
  components: {
    Home,
    List,
  },
}
